import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-2xl font-bold text-blue-400 mb-4">LegalClarityAI</h3>
            <p className="text-gray-300 mb-4">
              AI-powered legal document analysis that makes legal documents understandable for everyone.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 LegalClarityAI. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <p className="text-red-400 text-sm font-medium">
                ⚠️ Not Legal Advice: This tool provides AI-generated summaries for informational purposes only. 
                Always consult with a qualified attorney for legal advice.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 